import { z } from 'zod'

export const AmbulatoryQuoteSchema = z
	.object({
		description: z.string().refine((data) => data.length !== 0, {
			message: 'Required',
			path: ['description'],
		}),
	})
	.strict()
